import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Button,
  Confirm,
  Icon,
  Pagination,
  Popup,
  TableCell,
  TableRow,
} from "semantic-ui-react";
import { deleteMoh, listMoh } from "../../api/moh";
import PageLoader from "../../components/PageLoader";
import {
  Btn,
  Card,
  DataTable,
  EmptyState,
  Page,
  PageHeader,
  Spinner,
} from "../../components/ui";

function ListMoH() {
  const [page, setPage] = useState(1);

  const mohQuery = useQuery({
    queryKey: ["list-moh", page],
    queryFn: () => listMoh({ page }),
  });

  if (mohQuery.isLoading) return <PageLoader />;

  return (
    <Page>
      <PageHeader
        title="Music on Hold"
        actions={
          <>
            {mohQuery.isFetching && <Spinner />}
            <Btn as={Link} to="/admin/moh/getting-to-know-you">
              Company Info
            </Btn>
            <Btn as={Link} to="/admin/moh/create" variant="primary">
              Create Message
            </Btn>
          </>
        }
      />

      {mohQuery?.data.data.data.length > 0 ? (
        <DataTable
          columns={[
            { key: "name", label: "Name" },
            { key: "actions", label: "" },
          ]}
        >
          {mohQuery?.data.data.data.map((message) => {
            return (
              <TableRow key={message.id}>
                <TableCell>{message.name}</TableCell>
                <TableCell textAlign="right">
                  <Btn
                    as={Link}
                    to={`/admin/moh/create/${message.id}`}
                    style={{ marginRight: "8px" }}
                  >
                    View
                  </Btn>
                  <DeleteButton id={message.id} />
                </TableCell>
              </TableRow>
            );
          })}
        </DataTable>
      ) : (
        <Card>
          <EmptyState>No messages created.</EmptyState>
        </Card>
      )}

      {mohQuery.data.data.meta.last_page > 1 && (
        <div style={{ width: "100%", textAlign: "center" }}>
          <Pagination
            inverted
            activePage={page}
            totalPages={mohQuery.data.data.meta.last_page}
            onPageChange={(e, { activePage }) => setPage(activePage)}
          />
        </div>
      )}
    </Page>
  );
}

function DeleteButton({ id }) {
  const [open, setOpen] = useState(false);
  const queryClient = useQueryClient();

  const deleteMutation = useMutation({
    mutationFn: () => deleteMoh(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["list-moh"],
      });
    },
    onError: () => {
      toast.error(
        "There was problem deleting the music on hold. Please try again.",
        {
          toastId: "moh-deletion-error",
        },
      );
    },
  });

  return (
    <>
      <Popup
        position="bottom center"
        content={"Delete message"}
        basic
        trigger={
          <Button
            icon
            color="red"
            disabled={deleteMutation.isLoading}
            onClick={() => setOpen(true)}
          >
            <Icon name="delete" inverted />
          </Button>
        }
      />
      <Confirm
        open={open}
        header="Delete Music on Hold"
        content={`Really delete this music on hold message?`}
        confirmButton="Delete"
        onCancel={() => setOpen(false)}
        onConfirm={() => deleteMutation.mutate()}
      />
    </>
  );
}

export default ListMoH;
